import logoLockup from "../../assets/imgs/videobrief-logo-lockup.png";

export default function WebinarVaultLogo({
  height = 36,
  className = "",
  showTagline = true,
}) {
  return (
    <img
      src={logoLockup}
      alt="VideoBrief"
      className={`webinarvault-logo ${className}`}
      style={{
        height,
        width: "auto",
        maxWidth: "100%",
        display: "inline-block",
        objectFit: "contain",
      }}
    />
  );
}
